module.exports = __webpack_public_path__ + "9daff9991c18d74be0ff2be96973393f.MP3";